import { createContext } from 'react';
import { Loading } from '../types';

//Global loading state to handle loading timeouts across application
type LoadingContextType = {
  loading?: Loading;
  setLoading: (loading: Loading) => void;
};
export const LoadingContext = createContext<LoadingContextType>({
  setLoading: () => {},
});
